<template>
  <div class="button-option">
    <div class="mb-3">
      <span>按钮设置</span>
    </div>
    <div>
      <ul>
        <li>
          <span>开始按钮背景图</span>
          <el-button v-if="!bgImage" type="text" @click="onUploadImage">上传图片</el-button>
          <template v-else>
            <image-box :src="bgImage" @remove="onRemoveBgImage" />
          </template>
        </li>
        <li>
          <span>开始按钮文字</span>
          <el-input v-model="data.startText" :maxlength="16" show-word-limit placeholder="开始答题" @change="onChange" />
        </li>
        <li>
          <span>上一页按钮文字</span>
          <el-input v-model="data.prevText" :maxlength="16" show-word-limit placeholder="上一页" @change="onChange" />
        </li>
        <li>
          <span>下一页按钮文字</span>
          <el-input v-model="data.nextText" :maxlength="16" show-word-limit placeholder="下一页" @change="onChange" />
        </li>
        <li>
          <span>提交按钮文字</span>
          <el-input v-model="data.submitText" :maxlength="16" show-word-limit placeholder="提交" @change="onChange" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { uploadImage } from '@/api/file'
import ImageBox from '@/views/survey/edit/aside/appearance/ImageBox'

export default {
  name: 'ButtonOption',
  components: { ImageBox },

  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    bgImage() {
      return this.data.bgImage
    }
  },
  methods: {
    onChange() {
      this.$emit('change')
    },
    onUploadImage() {
      uploadImage().then(url => {
        this.data.bgImage = url
        this.onChange()
      })
    },
    onRemoveBgImage() {
      this.data.bgImage = ''
      this.onChange()
    }
  }
}
</script>
<style lang="scss" scoped>
.button-option {
  .el-input {
    width: 120px;
  }
}
</style>
